import edit from './edit';
import save from './save';
import accordionBlockMeta from './block.json';
import { accordionIcon as icon } from './icons';
import attributeVisibility from '@components/visibility/attributes.json';
import { getBlockLabelByName } from '@helpers/utils';
import './style.scss';

const { registerBlockType } = wp.blocks;
const { name, ...settings } = accordionBlockMeta;

const attributes = {
  ...settings.attributes,
  ...attributeVisibility,
};

registerBlockType(name, {
  ...settings,
  icon,
  attributes,
  edit,
  save,
  __experimentalLabel: (attributes) =>
    getBlockLabelByName(attributes, settings.title),
});
